const brand = {
  name: "Home Owners Club",
  logo: "/images/hoc-logo.png",
};

export default brand;
